import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
var DeviceWarrantyInfoView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceWarrantyInfoView, _super);
    function DeviceWarrantyInfoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.infoMessage = null;
        _this.loading = false;
        _this.email = "";
        return _this;
    }
    Object.defineProperty(DeviceWarrantyInfoView.prototype, "invateDisabled", {
        get: function () {
            if (!this.email)
                return true;
            var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !pattern.test(this.email);
        },
        enumerable: true,
        configurable: true
    });
    DeviceWarrantyInfoView.prototype.invite = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("user/invite", { email: this.email, serialNumber: this.device.serial })];
                    case 1:
                        data = (_b.sent()).data;
                        switch (data) {
                            case "inviteexits":
                                this.infoMessage = this.$t("inviteUserView.inviteexits").toString();
                                break;
                            case "invited":
                                this.infoMessage = this.$t("inviteUserView.invited").toString();
                                break;
                            case "existing":
                                this.infoMessage = this.$t("inviteUserView.alreadyAdded").toString();
                                break;
                            case "added":
                                this.infoMessage = this.$t("inviteUserView.deviceAdded").toString();
                                break;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        this.infoMessage = "Sending request failed";
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceWarrantyInfoView.prototype, "device", void 0);
    DeviceWarrantyInfoView = tslib_1.__decorate([
        Component
    ], DeviceWarrantyInfoView);
    return DeviceWarrantyInfoView;
}(Vue));
export default DeviceWarrantyInfoView;
